const Status = {
    Success                 : 200,
    Accepted                : 202,
    Moved                   : 302,
    NotModified             : 304,
    BadRequest              : 400,
    AccessDenied            : 403,
    NotFound                : 404,
    NotAllowed              : 405,
    NotAcceptable           : 406,
    Conflict                : 409,
    Gone                    : 410,
    HooktLoginFailed        : 420,
    TooLarge                : 413,
    UnsupportedMediaType    : 415,

    // custom errors
    InsufficientFund        : 437,

    ServerError             : 500,
    ServerUnavailable       : 503,
    Disabled                : 505,

    NotSubscribed           : 571,
};

const Codes = {
    None            : 0,
    General         : -1,
    InvalidArg      : -2,
    Timeout         : -3,
    Maintenance     : -4,
    Background      : -5,       // request is put into background job
    DatabaseDown    : -6,
    Deprecated      : -7,
    DatabaseError   : -8,
    MissingArg      : -9,

    Success                 : 1,

    // statns 2xx status
    Ok                      : 200,
    Accepted                : 202,

    // standard 4xx error/status
    Application             : 400,
    BadRequest              : 400,
    AccessDenied            : 403,
    NotFound                : 404,
    NotAllowed              : 405,
    Gone                    : 410,
    TooLarge                : 413,
    UnsupportedMediaType    : 415,

    SystemError             : 500,

    // database
    Duplicate       : 100,      // on register, phone# exists, but password isn't set
    TubeConflict    : 101,      // duplicate tube call
    BeingUsed       : 102,      // foreign key

    // user validation
    InvalidPin      : 200,
    NotAuthorized   : 201,
    InvalidPassword : 202,
    RequireLogin    : 203,      // on register, phone# exists, but password is set
    CannotSendSms   : 204,      // SMS platform doesn't support this phonenumber
    RequirePin      : 205,      // user registered, but not verified yet
    EmailExists     : 206,      // register with email and already exists
    NothingToUpdate : 207,
    MaxParticipant  : 208,      // maximum participants in a group reached

    IllegalPassword     : 209,
    IllegalPhonenumber  : 210,
    IllegalEmail        : 211,
    Lockout             : 212,  // account is locked
    FacebookIdLocked    : 213,

    // contact
    TargetNotFound  : 300,
    Ignored         : 301,
    CapReached      : 302,
    Outstanding     : 303,  // already outstanding invite exists
    OtherCapReached : 304,

    // conversation
    MemberNotFound  : 500,
    Profanity       : 501,

    // wallet
    Zong                : 600,
    Async               : 601,
    InsufficientPoints  : 602,

    // game
    GameInProgress      : 1000,
    NeedMorePlayers     : 1001,
    MissingContact      : 1002,
}


export {Status,Codes}

export default class GError {
    status:number;
    msg:string;
    code:number;
    constructor(status:number,msg:string,code:number=Codes.None) {
        this.status = status;
        this.msg = msg
        this.code = code
    }

    static get Status(){return Status}
    static get Codes(){return Codes}

    static get NotFound(){return NotFound}
    static get InvalidArg(){return InvalidArg}
    static get Duplicate(){return Duplicate}
    static get NotAllowed(){return NotAllowed}
    static get AccessDenied(){return AccessDenied}
    static get SystemError(){return SystemError}
    static get NotAuthorized(){return NotAuthorized}
}

export class InvalidArg extends GError {
    constructor(msg:string="Invalid Arguments", code:number=Codes.None){
        super(400,msg,code)
    }
}
export class NotFound extends GError {
    constructor(msg:string="Not Found", code:number=Codes.None){
        super(404,msg,code)
    }
}
export class Duplicate extends GError {
    constructor(msg:string="Conflict", code:number=Codes.None){
        super(409,msg,code)
    }
}
export class NotAllowed extends GError {
    constructor(msg:string="Not Allowed", code:number=Codes.None){
        super(405,msg,code)
    }
}
export class AccessDenied extends GError {
    constructor(msg:string="Access Denied", code:number=Codes.None){
        super(403,msg,code)
    }
}
export class SystemError extends GError {
    constructor(msg:string="System Error", code:number=Codes.SystemError){
        super(500,msg,code)
    }
}
export class NotAuthorized extends GError {
    constructor(msg:string="Not Authorized", code:number=Codes.NotAuthorized){
        super(401,msg,code)
    }
}